"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IcebreakerAppealCard = void 0;
const adaptivecards_1 = require("adaptivecards");
const __1 = require("../../..");
const IcebreakerAppealCard = (icebreaker, options) => {
    const card = __1.CardHelper.newCard();
    card.addItem((0, __1.AppealTitleWithManagementMenu)(icebreaker));
    if ((options === null || options === void 0 ? void 0 : options.isEdited) || (options === null || options === void 0 ? void 0 : options.reOpened)) {
        card.addItem(__1.CardHelper.create(adaptivecards_1.TextBlock, {
            weight: adaptivecards_1.TextWeight.Bolder,
            color: adaptivecards_1.TextColor.Good,
            wrap: true,
            text: options.isEdited
                ? (0, __1.getSurveyEditText)(options.votesInvalidated)
                : (0, __1.getSurveyReOpenedText)(),
        }));
    }
    if (icebreaker.description) {
        card.addItem(__1.CardHelper.create(adaptivecards_1.TextBlock, {
            text: icebreaker.description,
            spacing: adaptivecards_1.Spacing.Medium,
            wrap: true,
        }));
    }
    if (icebreaker.state === "open") {
        card.addAction(__1.CardHelper.create(adaptivecards_1.SubmitAction, {
            title: "Join Icebreaker",
            isPrimary: true,
            data: (0, __1.takingStartCommand)(icebreaker.id).toTaskFetchCommand(),
        }));
    }
    if (icebreaker.state === "closed") {
        card.addAction(__1.CardHelper.create(adaptivecards_1.SubmitAction, {
            // NOTE: if this text is changed, make sure to change the text in Polly preview as well.
            title: "View results",
            isPrimary: false,
            data: (0, __1.SurveyResultsViewHTMLCommand)(icebreaker.id, "icebreaker").toTaskFetchCommand(),
        }));
    }
    return card;
};
exports.IcebreakerAppealCard = IcebreakerAppealCard;
//# sourceMappingURL=IcebreakerAppealCard.js.map